import { render, staticRenderFns } from "./switchShiftModal.vue?vue&type=template&id=793a47cf&"
import script from "./switchShiftModal.vue?vue&type=script&lang=ts&"
export * from "./switchShiftModal.vue?vue&type=script&lang=ts&"
import style0 from "./switchShiftModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports